import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import { useEffect } from "react";
import { usePostLoginRedirect } from "./contexts/AuthContext";
import HomePage from "./pages/HomePage";
import AboutPage from "./pages/AboutPage";
import { CheckoutPage } from "./pages/CheckoutPage";
import CryptoCheckout from "./components/CryptoCheckout";
import { Roadmap } from "./components/Roadmap";
import { SetupPage } from "./pages/SetupPage";
import { UserManualPage } from "./pages/UserManualPage";
import { BugTrackerPage } from "./pages/BugTrackerPage";
import { RegistrationPage } from "./pages/RegistrationPage";
import DownloadsPage from "./pages/DownloadsPage";
import UserProfilePage from "./pages/UserProfilePage";
import FeaturesPage from "./pages/FeaturesPage";
import { LoginPage } from "./pages/LoginPage";
import { ForgotPasswordPage } from "./pages/ForgotPasswordPage";
import EmailContactForm from "./components/EmailContactForm";
import { ScrollToTopOnRouteChange } from "./components/ScrollToTopOnRouteChange";
import { AuthProvider } from "./contexts/AuthContext";
import { News } from "./pages/News";
import { initializeAnalytics } from "./utils/analytics";
import TermsOfService from "./pages/TermsOfService";
import Privacy from "./pages/PrivacyPolicy";
import "./App.css";
import PricingPage from "./pages/PricingPage";
import SupportPage from "./pages/SupportPage";
import AlgorithmServerPage from "./pages/AlgorithmServerPage";
import ResetPasswordPage from "./pages/ResetPasswordPage";
import EmailVerifiedPage from "./pages/EmailVerifiedPage";
import LaunchPromotion from "./pages/LaunchPromotion";
import DirectToVenuePage from "./pages/DirectToVenuePage";

function PostLoginRedirector() {
  usePostLoginRedirect();
  return null;
}

function App() {
  useEffect(() => {
    initializeAnalytics();
  }, []);

  return (
    <AuthProvider>
      <Router>
        <PostLoginRedirector />
        <ScrollToTopOnRouteChange />
        <Routes>
          <Route path="/" element={<HomePage />} />
          <Route path="/features" element={<FeaturesPage />} />
          <Route path="/checkout" element={<CheckoutPage />} />
          <Route path="/launch-promotion" element={<LaunchPromotion />} />
          <Route path="/reset-password" element={<ResetPasswordPage />} />
          <Route path="/email-verified" element={<EmailVerifiedPage />} />
          <Route path='/direct-to-venue' element={<DirectToVenuePage />} />
          <Route path="/about" element={<AboutPage />} />
          <Route path="/pricing" element={<PricingPage />} />
          <Route path="/support" element={<SupportPage />} />
          <Route path="/algorithm-server" element={<AlgorithmServerPage />} />
          <Route path="/crypto-checkout" element={<CryptoCheckout />} />
          <Route path="/roadmap" element={<Roadmap />} />
          <Route path="/setup" element={<SetupPage />} />
          <Route path="/guide" element={<SetupPage />} />
          <Route path="/manual" element={<UserManualPage />} />
          <Route path="/bug-tracker" element={<BugTrackerPage />} />
          <Route path="/register" element={<RegistrationPage />} />
          <Route path="/login" element={<LoginPage />} />
          <Route path="/forgot-password" element={<ForgotPasswordPage />} />
          <Route path="/terms" element={<TermsOfService />} />
          <Route path="/privacy" element={<Privacy />} />
          <Route path="/downloads" element={<DownloadsPage />} />
          <Route path="/profile" element={<UserProfilePage />} />
          <Route path="/contact" element={<EmailContactForm />} />
          <Route path="/news" element={<News />} />
        </Routes>
      </Router>
    </AuthProvider>
  );
}

export default App;
